<app-container title="Compliance Letters">
	<div class="flex items-end">
		<app-input label="Select department" class="mr-2"></app-input>
		<app-radio-group
			[items]="complianceStatus"
			type="compact"
			class="mr-2"
		></app-radio-group>
		<app-input label="Remarks" class="mr-2"></app-input>
		<app-button [icon]="ICON.ADD"></app-button>
	</div>
</app-container>
